import { Routes, Route, Outlet, Navigate } from "react-router-dom";
import * as React from "react";

import { Box, Typography } from "@mui/material";

import { useAuth } from "./hooks/useAuth";
import theme from "./theme";

import RequireAuth from "./components/RequireAuth/RequireAuth";
import DashboardRouter from "./routes/DashboardRouter/DashboardRouter";
import Account from "./routes/Account/Account";
import Login from "./routes/Login/Login";
import { PasswordResetLinkRequestWrapper } from "./routes/PasswordReset/PasswordResetLinkRequestWrapper";
import { PasswordResetWrapper } from "./routes/PasswordReset/PasswordResetWrapper";

const App = () => {
  const AppLayout = () => {
    return (
      <Box className="App" sx={{ backgroundColor: theme.palette.grey[50] }}>
        <Outlet />
      </Box>
    );
  };

  const ContentLayout = () => {
    return (
      <Box sx={{ minHeight: "100%", margin: "auto" }}>
        <Outlet />
      </Box>
    );
  };

  const NavigateCheckLogIn = ({ children }) => {
    const { isLoggedIn } = useAuth();
    if (isLoggedIn.current) {
      return <Navigate to="/dashboard" replace={true} />;
    }

    return children;
  };

  return (
    <Routes>
      <Route path="/" element={<AppLayout />}>
        <Route
          path=""
          element={
            <NavigateCheckLogIn>
              <Navigate to="/login" replace={true} />
            </NavigateCheckLogIn>
          }
        />
        <Route
          path="login"
          exact={false}
          element={
            <NavigateCheckLogIn>
              <Login />
            </NavigateCheckLogIn>
          }
        />
        <Route
          path="reset_password_link_request"
          element={<PasswordResetLinkRequestWrapper />}
        />
        <Route path="reset_password" element={<PasswordResetWrapper />} />
        <Route element={<ContentLayout />}>
          <Route
            path="dashboard"
            element={
              <RequireAuth>
                <DashboardRouter />
              </RequireAuth>
            }
          />
          <Route
            path="account/:accountId"
            element={
              <RequireAuth>
                <Account />
              </RequireAuth>
            }
          />
          <Route
            path="*"
            element={
              <RequireAuth>
                <Box
                  sx={{
                    height: "500px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <Typography variant="h1" color="primary">
                    Temporary 404 Not Found page
                  </Typography>
                </Box>
              </RequireAuth>
            }
          />
        </Route>
      </Route>
    </Routes>
  );
};

export default App;
